// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".info-documents__head[data-v-7c48029e]{margin-bottom:40px;text-align:center}@media(max-width:1279px){.info-documents__head[data-v-7c48029e]{margin-bottom:20px;text-align:left}}.info-documents__subtitle[data-v-7c48029e]:not(:last-child),.info-documents__title[data-v-7c48029e]:not(:last-child){margin-bottom:20px}.info-documents__descr[data-v-7c48029e]{max-width:1130px;text-align:left}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
